import React from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import PropTypes from 'prop-types'

import { getLogoByInsurer } from '@util/AuthUtil'

import { Logo } from './style'

const InsurerLogo = ({ style, disableClick }) => {
  const { insurance } = useParams()
  const navigate = useNavigate()

  const handleLogoClick = () => {
    if (!disableClick) {
      navigate('/unimed-assis/acompanhamento/empresas')
    }
  }

  return <Logo style={style} src={getLogoByInsurer(insurance)} onClick={handleLogoClick} />
}

InsurerLogo.propTypes = {
  style: PropTypes.shape({}),
  disableClick: PropTypes.bool,
}

InsurerLogo.defaultProps = {
  style: null,
  disableClick: false,
}

export default InsurerLogo
